import { render, staticRenderFns } from "./RealtimeApp.vue?vue&type=template&id=215be807&scoped=true&"
import script from "./RealtimeApp.vue?vue&type=script&lang=js&"
export * from "./RealtimeApp.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeApp.vue?vue&type=style&index=0&id=215be807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215be807",
  null
  
)

export default component.exports